import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormRadioMultiInputPreview({ ...props }) {
  return <BasePreview {...props}>
    <input type="radio" />
  </BasePreview>
}

export default define('form-radio-multi-input', FormRadioMultiInputPreview, Fragment)
  .shared(prop.share('FormRadioMultiInput', 'form-radio-multi-input'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

